import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";
import { Modal, Row, Col, Form } from 'react-bootstrap';
import { NumericFormat as NumberFormat } from "react-number-format";

import { deepEqual } from "../../../../../utils/object";
import { get as getStaff, billable } from "../../../../../actions/staff";
import { get as getPayment, save } from "../../../../../actions/payments";

import DatePickerEx from "../../../../../layout/date-picker";
import ConditionalButton from "../../../../../layout/conditional-button";
import { ConnectedSettingList } from "../../../../../layout/select/setting-list";
import { isGuid } from "../../../../../utils/string";

class Timecard extends React.Component {
    /**
     *
     */
    constructor(props) {
        super(props);
        this.state = this.mapPropsToState(props);
    }

    toDate = (v) => (v instanceof Date ? v : v != null ? new Date(v) : null);

    mapPropsToState = (props) => {
        const {
            uuid,
            personUuid,
            staffUuid,
            gross,
            source,
            recorded,
            reference,
            show
        } = props;

        const now = new Date();
        const s = this.toDate(recorded) ?? now;

        return {
            uuid,
            personUuid,
            staffUuid,
            recorded: s,
            gross,
            source,
            reference,
            show
        };
    };

    componentDidMount = async (e) => {
        await this.loadData();
    }

    componentDidUpdate = (oldProps) => {
        const oldSlice = this.mapPropsToState(oldProps);
        const newSlice = this.mapPropsToState(this.props);
        if (deepEqual(oldSlice, newSlice)) return;
        this.setState(newSlice, this.loadData);
    }

    loadData = async () => {
        const { staffUuid, personUuid, uuid } = this.state;
        let base = {}; 
        if (isGuid(uuid)) {
            const paymentData = await this.props.getPayment({ uuid });
            base = {...paymentData.item}
        }
        const staff = await this.props.getStaff({ uuid: staffUuid, personUuid });

        this.setState({
            staff: (staff ?? []).map((r) => ({
                ...r,
                value: r.uuid,
                label: `${r.Person.displayName}`
            })),
            ...base
        });
    };

    doPostChange = (e) => {

    }

    onCancel = async (e) => {
        if (this.props.onCancel) this.props.onCancel(e);
    }

    onHideModal = (e) => {
        this.onCancel(e);
    }

    onChange = (e) => {
        const { name, value } = e.target;
        if (this.state[name] === value) return;

        this.setState({ [name]: value }, this.doPostChange);
    };

    onOk = async () => {
        await this.props.save(this.state);
        if (this.props.onOk) this.props.onOk(this.state);
    }

    get canSave() {
        return ((this.state.gross > 0) && (isGuid(this.state.staffUuid)) && (this.state.reference?.length > 1));
    }

    render() {
        return (
            <>
                <Modal size="lg" backdrop="static" keyboard show={this.props.show} onHide={this.onHideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title id="staticBackdropLabel">{this.props.title || `Payment`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="g-3 pb-3 mt-1">
                            {!this.props.staffUuid &&
                                <>
                                    <Col xs="12">
                                        <div className="top-label">
                                            <Select
                                                id="staffUuid"
                                                value={this.state.staff?.find(option => option.value === this.state.staffUuid)}
                                                name="staffUuid"
                                                onChange={(e) => this.onChange(
                                                    {
                                                        target: {
                                                            option: e,
                                                            name: "staffUuid",
                                                            value: e.value
                                                        }
                                                    }
                                                )}
                                                classNamePrefix="react-select"
                                                placeholder="Staff Member"
                                                options={this.state.staff}
                                            >
                                            </Select>
                                            <Form.Label>STAFF MEMBER</Form.Label>
                                        </div>
                                    </Col>
                                </>
                            }
                            <Col xs="12" md="4">
                                <div className="top-label">
                                    <DatePickerEx
                                        id="recorded"
                                        selected={this.state.recorded}
                                        name="recorded"
                                        onChange={(e) => this.onChange({ target: { name: "recorded", value: e}})}
                                        className="form-control"
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        timeInputLabel="Time:"
                                        showTimeInput
                                    />
                                    <Form.Label>RECORDED</Form.Label>
                                </div>
                            </Col>
                            <Col xs="12" md="4">
                                <div className="top-label">
                                    <NumberFormat
                                        displayType="input"
                                        type="text"
                                        id="gross"
                                        name="gross"
                                        className="text-end form-control mb-2"
                                        prefix="$"
                                        thousandSeparator={false}
                                        decimalScale={2}
                                        allowNegative={false}
                                        value={this.state.gross ?? 0}
                                        onValueChange={(e) => this.onChange({ target: { name: "gross", value: e.floatValue } })}
                                        removeFormatting
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue == null || floatValue <= 5000000;
                                        }}
                                    />
                                    <Form.Label>AMOUNT</Form.Label>
                                </div>
                            </Col>
                            <Col xs="12" md="4">
                                <div className="top-label">
                                    <ConnectedSettingList name="source" setting="PAYMENT_SOURCES" category="Collections" value={this.state.source} onChange={this.onChange} />
                                    <Form.Label>SOURCE</Form.Label>
                                </div>
                            </Col>
                            <Col xs="12">
                                <div className="top-label">
                                    <Form.Control type="text" name="reference" value={this.state.reference || ""} onChange={this.onChange} />
                                    <Form.Label>REFERENCE</Form.Label>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.onCancel} icon="error-hexagon">cancel</ConditionalButton>
                        <ConditionalButton enabledVariant="outline-primary" display enabled={this.canSave} onEnabledClick={this.onOk} icon="save">ok</ConditionalButton>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

Timecard.propTypes = {
    auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps,
    {
        getStaff,
        getPayment,
        save,
        billable
    }
)(Timecard);
